export default __webpack_public_path__ + "static/media/pulse_light.29a562f6.svg";